import {isNil} from './utils.js';
import {CHANGE, DISABLED, SKIPPED} from './constants.js';
import {EventDispatcher} from './EventDispatcher.js';

/**
 * Executes the supplied task at the specified frequency, and invokes changeListener if a change
 * is detected.
 *
 *  Example Usage:
 *
 *  Director.globals.mrtsEndpointMonitor = new Monitor(CheckMRTSRouteTask, [Director.globals.dataStore], 300000, Director.globals.releaseInfo.title);
 *  Director.globals.mrtsEndpointMonitor.on(CHANGE, () => {
 *    log('MRTS endpoint change detected. Restarting...');
 *    window.location.reload();
 *  });
 */
export class Monitor extends EventDispatcher {
  constructor (taskClass, taskArgs, frequency, ownerName) {
    super();
    this.intervalID = -1;
    this.taskClass = taskClass;
    this.taskArgs = taskArgs;
    this.frequency = frequency;
    this.ownerName = ownerName;
    this.task = null;
    this.enabled = true;
  }

  start () {
    if (this.enabled) {
      this.stop();
      this.intervalID = setInterval(() => {
        this.doTask();
      }, this.frequency)
    }
  }

  doTask () {
    if (isNil(this.task) || this.task.complete) {
      this.task = new this.taskClass(...this.taskArgs);
      this.task.on(CHANGE, this.taskChangeListener.bind(this));
      this.task.start();
    } else {
      this.dispatchEvent(SKIPPED, {message: 'Task already in progress. Waiting until current task completes before initiating next task execution...'});
    }
  }

  stop () {
    clearInterval(this.intervalID);
  }

  disable () {
    this.stop();
    this.enabled = false;
    this.dispatchEvent(DISABLED);
  }

  taskChangeListener () {
    this.dispatchEvent(CHANGE);
  }
}
